// extracted by mini-css-extract-plugin
export var fadeInAnimation = "IssueConclusion-module--fadeInAnimation--+HjHs";
export var fadeOutAnimation = "IssueConclusion-module--fadeOutAnimation--TA2PB";
export var issueConclusion = "IssueConclusion-module--issueConclusion--vtE0T";
export var slideIn = "IssueConclusion-module--slideIn--28KvG";
export var slideInMobileNav = "IssueConclusion-module--slideInMobileNav--Jss7F";
export var slideInNav = "IssueConclusion-module--slideInNav--GDm94";
export var slideInTop = "IssueConclusion-module--slideInTop--o2gjT";
export var slideOut = "IssueConclusion-module--slideOut--Y-Onk";
export var slideOutTop = "IssueConclusion-module--slideOutTop--tM+CZ";